/* eslint-disable react-hooks/exhaustive-deps */
import React,{useEffect, useState} from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import BarcodeScanner from 'react-qr-barcode-scanner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faCheck, faCheckCircle, faFaceFrown, faFaceSmile } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { Grid, GridColumn } from '@progress/kendo-react-grid';


//Scan the participant's ID barcode and report their age

export const RataCheck=({onClose,areaId,rataCheck})=>{
    //Lookup the age by AttendeeID
    const [scanValue,setScanValue]=useState("");    
    const [showScanner,setShowScanner]=useState(true);
    const [age,setAge]=useState(0);
    const [className,setClassName]=useState("ageReport")
    const [checkedIn, setCheckedIn]=useState(false);
    const [checkIns,setCheckIns]=useState([]);
    
    const getAge = async (id)=>{
        const params=new URLSearchParams({id:id});
        const url= "api/index.php/program/getAge?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setAge(data.age);
        })
    }

    const getRataCheckIns = async (id)=>{
        const params=new URLSearchParams({id:id});
        const url= "api/index.php/program/getRataCheckIns?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setCheckIns(data);
        })
    }

    const onScan=(err,result)=>{
        if (result){
            console.log(result);
            setScanValue(result.text);
            hideScanner();
        }
    }

    const resetScanValue=()=>{
        setScanValue("");
    }

    const resetCheckedIn=()=>{
        setCheckedIn(false);
    }


    const openScanner=()=>{
        setAge(0);
    }
    const hideScanner=()=>{
        setShowScanner(false);
    }

    const getClass=()=>{
        console.log(age);
        if (age==="Age 14 or 14+" | age==="Age 18 or 18+"){
            setClassName("scanResult go ")
        }else{
            setClassName("scanResult stop")
        }
    }

    const gateScan=()=>{
        console.log("Gate Scan: " + areaId + " " + scanValue);
        const postData = new FormData();
        const url= "api/index.php/program/gateScan";
        postData.append("id",scanValue);
        postData.append("area",areaId);
        fetch (url,{
            method:"POST",
            body:postData
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            if (data.action=="GATE"){
                setCheckedIn(true);
            }
        })
    }

    useEffect(()=>{
        console.log("ScanValue:" + age);
        if (scanValue!==""){
            getAge(scanValue);
            resetCheckedIn();
            getRataCheckIns(scanValue);
        }
    },[scanValue]);

    useEffect(()=>{
        console.log("Age:" + age);
        if (age){
            getClass();
        }else{
            resetScanValue();
            resetCheckedIn();
            setShowScanner(true);
        }
    },[age])

    return(
        <Dialog title="RATA Verification" onClose={onClose} width={"90vw"} height={"75vh"}>
            {age!=""?
                <div className={className}>
                    <div style={{fontSize:"xxx-Large"}}>{age==="Age 14 or 14+"| age==="Age 18 or 18+"?<FontAwesomeIcon icon={faFaceSmile} />:<FontAwesomeIcon icon={faFaceFrown}/>}</div>
                    <h1>{scanValue}</h1>
                    <h1>{age}</h1>
                    {checkedIn?<div style={{fontSize:"xxx-Large", padding:"10px"}}><FontAwesomeIcon icon={faCheck} /></div>:null}
                    {!checkedIn?
                        <>
                                <Grid
                                    data={checkIns}
                                >
                                    <GridColumn title={"This participant has previously checked in to:"} field='AreaName'/>
                                </Grid>
                            <div style={{paddingTop:"20px"}}><Button size='large' fillMode='outline' style={{color:"white",width:"95%"}} onClick={gateScan}>Check In</Button></div>
                        </>
                    :null}
                    <div style={{paddingTop:"20px"}}><Button size='large' fillMode='outline' style={{color:"white",width:"95%"}} onClick={openScanner}>Scan Again</Button></div>
                </div>
            :null}
            {showScanner?
            <>
            <div style={{fontSize:"xxx-Large", textAlign:"center"}}><FontAwesomeIcon icon={faCamera} /></div>
            <p>Use the device camera to scan the barcode found on the Jamboree ID.</p>
            <BarcodeScanner width={"90%"} onUpdate={onScan}></BarcodeScanner>
            </>
            :null}
        </Dialog>
    )

}